export const PAYMENT_STATUS_PATHS = {
  COMPLETED: 'completed',
  FAIL: 'fail',
};

export const REDIRECT_PATH = '/i';
